module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Chapter IV")])]), _vm._v(" "), _c('p', {
    staticClass: "vh1"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("North of the village is a logwood grove whose thorns")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("litter its dry shade. The broken road has boulders,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and quartz that glistens like rain. The logwoods were once")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("part of an estate with its windmill as old as")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the village below it. The abandoned road runs")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("past huge rusted cauldrons, vats for boiling the sugar,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and blackened pillars. These are the only ruins")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("left here by history, if history is what they are.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("The twisted logwood trunks are orange from sea-blast;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("above them is a stand of surprising cactus.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Philoctete limped to his yam garden there. He passed")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("through the estate shuddering, cradling his cutlass,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("bayed at by brown, knotted sheep repeating his name.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“Beeeeeh, Philoctete!” Here, in the Atlantic wind,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the almonds bent evenly like a candle-flame.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The thought of candles brought his own death to mind.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The wind turned the yam leaves like maps of Africa,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("their veins bled white, as Philoctete, hobbling, went")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("between the yam beds like a patient growing weaker")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("down a hospital ward. His skin was a nettle,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("his head a market of ants; he heard the crabs groan")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("from arthritic pincers, he felt a mole-cricket drill")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("his sore to the bone. His knee was radiant iron,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("his chest was a sack of ice, and behind the bars")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of his rusted teeth, like a mongoose in a cage,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("a scream was mad to come out; his tongue tickled its claws")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("on the roof of his mouth, rattling its bars in rage.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He saw the blue smoke from the yards, the bamboo poles")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("weighed down by nets, the floating feather of the priest.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("When cutlass cut smoke, when cocks surprise their arseholes")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("by shitting eggs,")]), _vm._v(" he cursed, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("black people go get rest")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("from God;")]), _vm._v(" at which point a fierce cluster of arrows")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("targeted the sore, and he screamed in the yam rows.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He stretched out the foot. He edged the razor-sharp steel")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("through pleading finger and thumb. The yam leaves recoiled")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("in a cold sweat. He hacked every root at the heel.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He hacked them at the heel, noticing how they curled,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("head-down without their roots. He cursed the yams:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Salope!")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("You all see what it’s like without roots in this world?”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then sobbed, his face down in the slaughtered leaves. A sap")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("trickled from their gaping stems like his own sorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("A fly quickly washed its hands of the massacre.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Philoctete felt an ant crawling across his brow.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It was the breeze. He looked up at a blue acre")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and a branch where a swift settled without a cry.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He felt the village through his back, heard the sea-hum")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of transports below. The sea-swift was watching him.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Then it twittered seaward, swallowed in the cloud-foam.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("For as long as it takes a single drop to dry")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("on the wax of a dasheen leaf, Philoctete lay")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("on his pebbled spine on hot earth watching the sky")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("altering white continents with its geography.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He would ask God’s pardon. Over the quiet bay")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the grass smelt good and the clouds changed beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Next he heard warriors rushing towards battle,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but it was wind lifting the dead yams, the rattle")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of a palm’s shaken spears. Herdsmen haieing cattle")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("who set out to found no cities; they were the found,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("who were bound for no victories; they were the bound,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("who levelled nothing before them; they were the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He would be the soul of patience, like an old horse")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("stamping one hoof in a pasture, rattling its mane")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("or swishing its tail as flies keep circling its sores;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("if a horse could endure afflictions so could men.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He held to a branch and tested his dead hoof once")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("on the springy earth. It felt weightless as a sponge.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I sat on the white terrace waiting for the cheque.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our waiter, in a black bow-tie, plunged through the sand")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("between the full deck-chairs, bouncing to discotheque")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("music from the speakers, a tray sailed in one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The tourists revolved, grilling their backs in their noon")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("barbecue. The waiter was having a hard time")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with his leather soles. They kept sliding down a dune,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but his tray teetered without spilling gin-and-lime")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("on a scorched back. He was determined to meet the")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("beach’s demands, like a Lawrence of St. Lucia,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("except that he was trudging towards a litre")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of self-conscious champagne. Like any born loser")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("he soon kicked the bucket. He rested his tray down,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wiped the sand from the ice-cubes, then plunked the cubes in")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the bucket, then the bottle; after this was done,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("he seemed ready to help the wife stuff her boobs in")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("her halter, while her husband sat boiling with rage")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("like a towelled sheik. Then Lawrence frowned at a mirage.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That was when I turned with him towards the village,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and saw, through the caging wires of the noon sky,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("a beach with its padding panther; now the mirage")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("dissolved to a woman with a madras head-tie,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but the head proud, although it was looking for work.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("I felt like standing in homage to a beauty")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("that left, like a ship, widening eyes in its wake.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“Who the hell is that?” a tourist near my table")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("asked a waitress. The waitress said, “She? She too proud!”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("As the carved lids of the unimaginable")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("ebony mask unwrapped from its cotton-wool cloud,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the waitress sneered, “Helen.” And all the rest followed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba396f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 84
// module chunks = 0